import { WorkTimeEntryToCreate } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { ValidationFn } from '../useValidation';
import { ValidationUtils } from '../ValidationUtils';
import { validateBreak } from './validateBreak';
export function validateWorkTimeEntryBreaks(workTimeEntry: WorkTimeEntryToCreate): ValidationFn {
  return ValidationUtils.combine(workTimeEntry.breaks.map(b => validateBreak(b, workTimeEntry)));
}